module.exports = __webpack_public_path__ + "static/media/cyuce015.7c90c624.jpg";